import React from 'react';
import { any, string, oneOfType, array, object } from 'prop-types';
import { last, get, includes } from 'lodash';
import { OrderEventsFeedConsumer } from '../../firebase/OrderEventsFeed';
import { withReloadable } from '../../../hoc';
import QueryOrderById from '../../graphql/getOrderById';
import { hasPermissionBySalesChannel, getPickingStatus } from '../../../utils/misc';

const OrderStatus = ({ orderId, children, session }) => (
    <OrderEventsFeedConsumer>
        {({ events, loading: eventsLoading }) => (
            <QueryOrderById
                ts={includes(['1', '2', '20'], get(last(events), 'status', 0)) ? false : get(last(events), 'status', 0)}
                variables={{ filters: [{ field: 'idOrder', value: orderId }] }}
                fetchPolicy='network-only'
            >
                {({ data, loading: orderLoading, networkStatus }) => {
                    if (session && !hasPermissionBySalesChannel(get(session, 'salesChannels', []), get(data, 'salesChannelId'))) return null;
                    return children({
                        data,
                        events,
                        loading: (eventsLoading || orderLoading),
                        ts: get(last(events), 'ts', new Date().toISOString()),
                        lastKnownStatus: {
                            code: get(data, 'assignInfo.status.code', '-1'),
                            label: getPickingStatus(get(data, 'assignInfo.status.code', '-1'))
                        },
                        networkStatus
                    });
                }}
            </QueryOrderById>
        )}
    </OrderEventsFeedConsumer>
);

OrderStatus.propTypes = {
    children: any,
    orderId: string.isRequired,
    session: oneOfType([array, object])
};

OrderStatus.defaultProps = {
    session: null
};

export default withReloadable(OrderStatus, ['orderId']);
